module.exports = __webpack_public_path__ + "img/linghuo.82557acd.png";